import styled from "styled-components";

export const StyledTitleKeyword = styled.span`
	font-weight: 600;
	font-family: monospace;
	color: #1f2937;
	word-break: break-all;
`;

export const StyledKeywordInner = styled.div`
	padding: 4px 0;
`;

export const StyledKeywordHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	flex-wrap: wrap;
	margin-bottom: 12px;
`;

export const StyledKeywordHeaderInfo = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const StyledKeywordCount = styled.span`
	font-size: 12px;
	color: #6b7280;
`;

export const StyledKeywordToolbar = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
`;

export const StyledKeywordSearchInput = styled.input`
	min-width: 240px;
	padding: 10px 12px;
	border: 1px solid #d1d5db;
	border-radius: 10px;
	outline: none;
	font-size: 14px;

	&:focus {
		border-color: #2563eb;
		box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
	}
`;

export const StyledKeywordToggleButton = styled.button`
	border: 1px solid #d1d5db;
	background: #ffffff;
	color: #374151;
	padding: 10px 14px;
	border-radius: 10px;
	cursor: pointer;
	font-weight: 600;

	&:hover {
		background: #f3f4f6;
	}
`;

export const StyledTemplateNameInput = styled.input`
	width: 100%;
	padding: 10px 12px;
	border: 1px solid #d1d5db;
	border-radius: 10px;
	outline: none;
	font-size: 14px;
	margin-top: 8px;

	&:focus {
		border-color: #2563eb;
		box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
	}
`;

export const StyledKeywordWrap = styled.div`
	max-height: 320px;
	overflow-y: auto;
	padding: 12px;
	border: 1px solid #e5e7eb;
	border-radius: 14px;
	background: #fafafa;
`;

export const StyledKeywordSection = styled.div`
	& + & {
		margin-top: 16px;
		padding-top: 16px;
		border-top: 1px solid #e5e7eb;
	}
`;

export const StyledKeywordSectionTitle = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	margin-bottom: 10px;
	font-size: 12px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #374151;

	span {
		padding: 2px 8px;
		border-radius: 999px;
		background: #e5eefc;
		color: #1d4ed8;
		font-size: 11px;
	}
`;

export const StyledKeywordGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
	gap: 8px;
`;

export const StyledKeywordBox = styled.button<{ isChecked: boolean }>`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 8px;
	padding: 10px 12px;
	border: 1px solid ${({ isChecked }) => (isChecked ? "#2563eb" : "#e5e7eb")};
	border-radius: 12px;
	background: ${({ isChecked }) => (isChecked ? "#eff6ff" : "#ffffff")};
	cursor: pointer;
	text-align: left;
	transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;

	&:hover {
		border-color: #93c5fd;
		background: #f8fbff;
		transform: translateY(-1px);
	}

	.top {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 10px;
	}

	.fa-copy {
		cursor: pointer;
		color: #6b7280;
		flex-shrink: 0;

		&:hover {
			color: #2563eb;
		}
	}

	.desc {
		color: #6b7280;
		font-size: 12px;
		line-height: 1.45;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
`;

export const StyledKeywordEmpty = styled.div`
	padding: 20px 12px;
	text-align: center;
	color: #6b7280;
	font-size: 14px;
`;

export const StyledUpdateContentWrap = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	/* When this wrap is inside the full-screen builder dialog, it must fill the
	   remaining height so ShellWrap's height:100% resolves to the pane area.
	   flex:1 + min-height:0 propagate the height from the dialog flex chain. */
	flex: 1;
	min-height: 0;
`;

export const StyledEditorModeCard = styled.div`
	border: 1px solid #dbe3f0;
	border-radius: 14px;
	background: #f8fbff;
	padding: 14px 16px;
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const StyledEditorModeTitle = styled.div`
	font-size: 14px;
	font-weight: 700;
	color: #1f2937;
`;

export const StyledEditorModeDesc = styled.div`
	font-size: 13px;
	line-height: 1.55;
	color: #4b5563;
`;

export const StyledEditorModeActions = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
`;

export const StyledEditorModeButton = styled.button<{ primary?: boolean }>`
	border: 1px solid ${({ primary }) => (primary ? "#2563eb" : "#d1d5db")};
	background: ${({ primary }) => (primary ? "#2563eb" : "#ffffff")};
	color: ${({ primary }) => (primary ? "#ffffff" : "#374151")};
	padding: 10px 14px;
	border-radius: 10px;
	cursor: pointer;
	font-weight: 600;

	&:hover {
		opacity: 0.92;
	}
`;

export const StyledSimpleEditorWrap = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const StyledSimpleHint = styled.div`
	font-size: 12px;
	line-height: 1.5;
	color: #6b7280;
`;

export const StyledSimpleTextarea = styled.textarea`
	width: 100%;
	min-height: 520px;
	padding: 14px 16px;
	border: 1px solid #d1d5db;
	border-radius: 14px;
	outline: none;
	font-size: 14px;
	line-height: 1.6;
	font-family: "Courier New", Courier, monospace;
	resize: vertical;
	background: #ffffff;

	&:focus {
		border-color: #2563eb;
		box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
	}
`;

export const StyledSimpleHelpGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
	gap: 12px;
`;

export const StyledSimpleHelpHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	flex-wrap: wrap;
	padding: 10px 12px;
	border: 1px dashed #dbe3f0;
	border-radius: 12px;
	background: #ffffff;
`;

export const StyledSimpleHelpSummary = styled.div`
	font-size: 13px;
	line-height: 1.5;
	color: #4b5563;
`;

export const StyledSimpleHelpCard = styled.div`
	border: 1px solid #e5e7eb;
	border-radius: 12px;
	padding: 12px;
	background: #ffffff;
`;

export const StyledSimpleHelpTitle = styled.div`
	font-size: 12px;
	font-weight: 700;
	text-transform: uppercase;
	letter-spacing: 0.05em;
	color: #374151;
	margin-bottom: 8px;
`;

export const StyledSimpleHelpCode = styled.pre`
	margin: 0;
	white-space: pre-wrap;
	word-break: break-word;
	font-size: 12px;
	line-height: 1.5;
	font-family: "Courier New", Courier, monospace;
	color: #111827;
`;

export const StyledSimpleGuideList = styled.ul`
	margin: 0;
	padding-left: 18px;
	color: #374151;
	font-size: 13px;
	line-height: 1.6;
`;

export const StyledInlineCode = styled.code`
	padding: 2px 6px;
	border-radius: 6px;
	background: #eef2ff;
	color: #1d4ed8;
	font-size: 12px;
	font-family: "Courier New", Courier, monospace;
`;

// ---------------------------------------------------------------------------
// Editor mode segmented toggle (Builder / Easy / HTML)
// ---------------------------------------------------------------------------

export const StyledModeToggleRow = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 4px;
	background: #f1f5f9;
	border: 1px solid #e2e8f0;
	border-radius: 10px;
	width: fit-content;
`;

export const StyledModeToggleBtn = styled.button<{ active?: boolean }>`
	border: none;
	background: ${({ active }) => (active ? "#ffffff" : "transparent")};
	color: ${({ active }) => (active ? "#1d4ed8" : "#6b7280")};
	font-weight: ${({ active }) => (active ? 700 : 500)};
	font-size: 13px;
	padding: 6px 14px;
	border-radius: 7px;
	cursor: pointer;
	box-shadow: ${({ active }) => (active ? "0 1px 3px rgba(0,0,0,0.10)" : "none")};
	transition: background 0.15s, color 0.15s;

	&:hover {
		color: #1d4ed8;
	}
`;

// ---------------------------------------------------------------------------
// Compact two-column header row (Tên template + Subject on one line)
// ---------------------------------------------------------------------------

export const StyledCompactHeaderRow = styled.div`
	display: flex;
	gap: 16px;
	padding: 10px 16px 0;

	@media (max-width: 640px) {
		flex-direction: column;
	}
`;

export const StyledCompactHeaderCol = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const StyledInfoIcon = styled.span`
	margin-left: 4px;
	cursor: help;
	color: #6b7280;
	font-size: 12px;
	user-select: none;
`;
